<template>
<div class="flex-center">
  <div class="app-header"></div>
  <div class="app-body">
    <div class="loader-container text-center">
      <div class="icon">
        <div class="sk-folding-cube">
          <div class="sk-cube1 sk-cube"></div>
          <div class="sk-cube2 sk-cube"></div>
          <div class="sk-cube4 sk-cube"></div>
          <div class="sk-cube3 sk-cube"></div>
        </div>
      </div>
      <div class="title">Logging in...</div>
    </div>
    <div class="app-block">
      <div class="app-form" v-if="isLogin">
        <div class="form-header">
          <div class="app-brand">
            <template v-if="logoLoginUrl">
              <img class="img-responsive" :src="logoLoginUrl" />
            </template>
            <template v-else>
              {{ title }}
            </template>
          </div>
        </div>
        <div v-if="message" :class="`alert ${messageClass || ''}`">{{ message }}</div>
        <div v-if="intro" class="login-intro" v-html="intro"></div>
        <form v-on:submit='submit' v-if="form">
          <div class="input-group">
            <span class="input-group-addon" id="basic-addon1">
              <i class="fa fa-user" aria-hidden="true"></i></span>
            <input v-model="username" type="text" class="form-control" :placeholder="$t('Login.username')" aria-describedby="basic-addon1">
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="basic-addon2">
              <i class="fa fa-key" aria-hidden="true"></i></span>
            <input v-model="password" type="password" class="form-control" :placeholder="$t('Login.password')" aria-describedby="basic-addon2">
          </div>
          <div class="input-group">
            <a href=""></a>
          </div>
          <div class="text-center">
            <input type="submit" class="btn btn-success btn-submit" :value="$t('Login.login')">
          </div>
        </form>
        <div v-if="outro" class="login-outro" v-html="outro"></div>
      </div>

      <div class="app-form" v-else-if="isForgot">
        <div class="form-header">
          <div class="app-brand">
            <template v-if="logoLoginUrl">
              <img class="img-responsive" :src="logoLoginUrl" />
            </template>
            <template v-else>
              {{ title }}
            </template>
          </div>
        </div>
        <div v-if="message" :class="`alert ${messageClass || ''}`">{{ message }}</div>
        <form v-on:submit='submit' v-if="form">
          <div class="input-group">
            <span class="input-group-addon" id="forget-password">
              <i class="fa fa-user" aria-hidden="true"></i></span>
            <input v-model="username" type="text" class="form-control" :placeholder="$t('Login.username')" aria-describedby="forget-password">
          </div>
          <div class="input-group">
            <a href=""></a>
          </div>
          <div class="text-center">
            <input type="submit" class="btn btn-success btn-submit" :value="$t('Login.recover')">
          </div>
        </form>
        <div class="login-outro">
          <a href="javascript: void 0" @click="backToLogin">{{$t('Login.back')}}</a>
        </div>
      </div>

      <div class="app-form" v-else-if="isRecover">
        <div class="form-header">
          <div class="app-brand">
            <template v-if="logoLoginUrl">
              <img class="img-responsive" :src="logoLoginUrl" />
            </template>
            <template v-else>
              {{ title }}
            </template>
          </div>
        </div>
        <div v-if="message" :class="`alert ${messageClass || ''}`">{{ message }}</div>
        <div v-if="recoveryIntro" class="login-intro" v-html="recoveryIntro"></div>
        <form v-on:submit='submit' v-if="form">
          <div class="input-group  tooltip-with-pre" :data-balloon="advancedPasswordComplexityTooltip" data-balloon-pos="right">
            <span class="input-group-addon" id="recover-password">
              <i class="fa fa-key" aria-hidden="true"></i></span>
            <input v-model="password" type="password" class="form-control" :placeholder="$t('Login.newPassword')" aria-describedby="recover-password">
          </div>

          <ul v-show="password" :class="`complexity-bar ${advancedPasswordComplexity}`">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>

          <div class="input-group">
            <span class="input-group-addon" id="confirm-password">
              <i class="fa fa-key" aria-hidden="true"></i></span>
            <input v-model="confirmation" type="password" class="form-control" :placeholder="$t('Login.confirmPassword')" aria-describedby="confirm-password">
          </div>
          <div class="input-group">
            <a href=""></a>
          </div>
          <div class="text-center">
            <input type="submit" class="btn btn-success btn-submit" :value="$t('Login.change')">
          </div>
        </form>
        <div v-if="outro && isLogin" class="login-outro" v-html="outro"></div>
      </div>
      <div class="pad-15 locales" v-if="false">
        <template v-for="locale in locales">
          <button type="button" :class="['btn', 'btn-xs', {'btn-default': locale != currentLocale, 'active': locale == currentLocale}]" v-on:click="changeLocale(locale)">
            <img :src="icon(locale)" height="32" />
          </button>
        </template>
      </div>
      <!-- <div class="pad-15 locales form-control" :key="currentLocale"> -->
        <short-lang-picker id="login-locale-picker" class="form-control" @changeLocale="changeLocale"/>
        <!-- <dl class="dropdown">
          <input type="checkbox" id="login-locale-picker" v-model="isDropDownOpen">
          <dt>
            <label for="login-locale-picker" class="selected">
              <span>
                <img :src="icon(currentLocale)" height="32" />
                {{ $t('Lang.' + currentLocale) }}
              </span>
            </label>
          </dt>
          <dd>
            <ul>
              <li v-for="(locale, index) in locales" :key="index">
                <a v-on:click="changeLocale(locale)" :class="locale === currentLocale ? 'selected' : ''">
                  <span>
                    <img :src="icon(locale)" height="32" />
                    {{ $t('Lang.' + locale) }}
                  </span>
                </a>
              </li>
            </ul>
          </dd>
        </dl> -->

      <!-- </div> -->
    </div>
  </div>
  <div class="app-footer">
  </div>
</div>
</template>

<script>

import ShortLangPicker from '../Elements/ShortLangPicker.vue';
import { getPasswordComplexity, hasDigit, hasLower, hasSpecial, hasUpper, isStrongPassword } from '../lib/password'

var view = require('../view.js'),
    viewData = {
      'username': '',
      'password': '',
      'confirmation': '',
      'message': null,
      'messageClass': 'alert-danger',
      form: true,
      // isDropDownOpen: false
    };

export default view(viewData, {
  components: {
    ShortLangPicker
  },
  props: {
  },
  computed: {
    isLogin() {
      return !this.isForgot && !this.isRecover;
    },
    isForgot() {
      return this.$parent.viewIndex === 'reset' && (!this.$parent.viewParam || this.$parent.viewParam.indexOf('@') > 0);
    },
    isRecover() {
      return this.$parent.viewIndex === 'reset' && this.$parent.viewParam;
    },
    logoLoginUrl() {
      return this.$parent.logoLoginUrl;
    },
    title() {
      return this.$parent.title;
    },
    intro() {
      return this.$root.getLocaleProperty('loginIntro');
    },
    recoveryIntro() {
      return this.$root.getLocaleProperty('recoveryIntro');
    },
    outro() {
      return this.$root.getLocaleProperty('loginOutro');
    },
    locales() {
      return Object.keys(this.$i18n.messages);
    },
    currentLocale() {
      return this.$i18n.locale
    },
    prefilledEmail() {
      return (this.isForgot && this.$parent.viewParam.indexOf('@') > 0 ? this.$parent.viewParam : '')
          || this.$root.getHashOption('customernum', '')
    },
    advancedPasswordComplexity() {
      const x = getPasswordComplexity(this.password);
      return !this.password.length ? '' : x === 'none' ? 'low' : x;
    },
    advancedPasswordComplexityTooltip() {
      const minLength = Math.max(6, this.$root.passwordMinLength || 6);
      const complexity = this.$root.passwordComplexity || 'weak';
      return [
        [x => x.length >= minLength, 'Password.lengthDesc', {x: minLength}],
        [hasLower, 'Password.lowerDesc'],
        complexity === 'strong' || complexity === 'medium' ? [hasUpper, 'Password.upperDesc'] : null,
        [hasDigit, 'Password.digitDesc'],
        complexity === 'strong' ? [hasSpecial, 'Password.specialDesc'] : null,
      ]
          .filter( x => x)
          .map(([p, l, ...rest]) => `${p(this.password || '') ? '✓' : '✘'} ${this.$t(l, ...rest)}`)
          .join('\n');
    },
  },
  mounted() {
    this.username = this.prefilledEmail;
    // window.addEventListener('click', this.closeDropDown);
  },
  // beforeUnmount() {
  //   window.removeEventListener('click', this.closeDropDown);
  // },
  methods: {
    // closeDropDown() {
    //   if (this.isDropDownOpen) {
    //     this.isDropDownOpen = false;
    //   }
    // },
    submit(evt) {
      evt.preventDefault();

      if (this.isLogin) {
        if (typeof this.username == 'undefined' || this.username == '' ||  typeof this.password == 'undefined' || this.password == '') {
          this.message = this.$t('Login.enterPwd');
          return;
        }

        this.$parent.containerClass = '__loading';
        setTimeout(function () { this.login() }.bind(this), 3000)
      } else if (this.isForgot) {
        if (typeof this.username == 'undefined' || this.username == '') {
          this.message = this.$t('Login.enterUser');
          return;
        }

        this.recover();
      } else if (this.isRecover) {
        if (typeof this.password == 'undefined' || this.password == '' || !isStrongPassword(this.password, this.$root.passwordComplexity, this.$root.passwordMinLength)) {
          this.message = this.$t('Login.enterPwd');
          return;
        }

        if (this.confirmation !== this.password) {
          this.message = this.$t('Login.enterSameConfirmPwd');
          return;
        }

        this.change();
      }
    },
    login() {
      this.$http.post(this.$root.url + 'auth/', {
        username: this.username,
        password: this.password
        // impersonate: false
      }).then(function(res) {
          this.$parent.containerClass = '';
          this.$parent.setUser(res.data.result);
          this.username = '';
          this.password = '';
          this.message  = null;
          if (window.location.pathname === '/app/login') {
            // use history to avoid reload
            window.history.replaceState(null, null, '/');
            this.$parent.resolveRoute('')
          }
        }.bind(this),
        function(res) {
          this.$parent.containerClass = '';
          this.messageClass = 'alert-danger';
          this.message = this.$t('Login.invalidUserOrPwd');
        }.bind(this));
    },
    recover() {
      this.$http.post(this.$root.url + 'auth/reset', {
        username: this.username,
        // impersonate: false
      }).then(function(res) {
          this.$parent.containerClass = '';
          this.username = '';
          this.messageClass = 'alert-info';
          this.message = res.data.error || this.$t('Login.checkEmailForRecoverLink');
          this.form = !!res.data.error;
        }.bind(this),
        function(res) {
          this.$parent.containerClass = '';
          this.messageClass = 'alert-danger';
          this.message = this.$t('Login.invalidUserOrPwd');
        }.bind(this));
    },
    change() {
      this.$http.post(this.$root.url + 'auth/reset/' + this.$parent.viewParam.replace(':', '/'), {
        password: this.password,
        // impersonate: false
      }).then(function(res) {
          this.$parent.containerClass = '';
          this.username = '';
          this.password = '';
          this.message  = null;
          this.$parent.openView('Login');
        }.bind(this),
        function(res) {
          this.$parent.containerClass = '';
          this.messageClass = 'alert-danger';
          this.message = res.data.error || this.$t('Login.invalidUserOrPwd');
        }.bind(this));
    },
    backToLogin() {
      window.location = this.$root.url + '../app/login';
    },
    changeLocale(locale) {
      this.$parent.applyLanguage(locale);
    },
    // icon(locale) {
    //   return `/img/flags/${locale}.png`;
    // }
  }
});
</script>
<style scoped>
  .locales {
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    left: auto;
    width: auto;
    background: no-repeat;
    border: 0;
  }

  .locales .btn {
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none !important;
  }

  .locales .btn.btn-default {
    box-shadow: none;
  }

  .complexity-bar {
    display: flex;
    list-style: none;
    flex-direction: row;
    width: 100%;
    height: 6px;
    flex: 1;
    margin: 0 0 16px;
    padding: 0;
  }

  .complexity-bar li {
    display: flex;
    flex: 1;
    margin: 0 2px 0;
    background-color: #999;
    padding: 0;
  }

  .complexity-bar li:last-child {
    margin-right: 0;
  }

  .complexity-bar.low li:nth-child(5n+1) {
    background-color: red;
  }

  .complexity-bar.weak li:nth-child(5n+1), .complexity-bar.weak li:nth-child(5n+2) {
    background-color: orange;
  }

  .complexity-bar.medium li:nth-child(5n+1), .complexity-bar.medium li:nth-child(5n+2), .complexity-bar.medium li:nth-child(5n+3) {
    background-color: orange;
  }

  .complexity-bar.strong li:nth-child(5n+1), .complexity-bar.strong li:nth-child(5n+2), .complexity-bar.strong li:nth-child(5n+3), .complexity-bar.strong li:nth-child(5n+4) {
    background-color: green;
  }

  .complexity-bar.extra-strong li:nth-child(5n+1), .complexity-bar.extra-strong li:nth-child(5n+2), .complexity-bar.extra-strong li:nth-child(5n+3), .complexity-bar.extra-strong li:nth-child(5n+4) {
    background-color: green;
  }

  .tooltip-with-pre::after {
    white-space: pre;
  }
</style>
